/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type AnalyticsSignalScope = {
  /**
   * Required for manual; absent for stream
   */
  runId?: string | undefined;
  sensorId: string;
  /**
   * Evaluation population: stream or manual
   */
  trigger?: string | undefined;
};

/** @internal */
export type AnalyticsSignalScope$Outbound = {
  run_id?: string | undefined;
  sensor_id: string;
  trigger: string;
};

/** @internal */
export const AnalyticsSignalScope$outboundSchema: z.ZodMiniType<
  AnalyticsSignalScope$Outbound,
  AnalyticsSignalScope
> = z.pipe(
  z.object({
    runId: z.optional(z.string()),
    sensorId: z.string(),
    trigger: z._default(z.string(), "stream"),
  }),
  z.transform((v) => {
    return remap$(v, {
      runId: "run_id",
      sensorId: "sensor_id",
    });
  }),
);

export function analyticsSignalScopeToJSON(
  analyticsSignalScope: AnalyticsSignalScope,
): string {
  return JSON.stringify(
    AnalyticsSignalScope$outboundSchema.parse(analyticsSignalScope),
  );
}
